import { API } from 'aws-amplify';
import { UpdateNotificationSettingsPayload, NotificationSettings } from './types';

/**
 * Updates notification settings for a company
 *
 * @param companyId - Company identifier
 * @param payload - Notification settings to update
 * @returns Promise with the updated notification settings
 */
export const updateNotificationSettings = async (
	companyId: string,
	payload: UpdateNotificationSettingsPayload
): Promise<NotificationSettings> =>
{
	try
	{
		const response = await API.patch('revisedResources', `/configurations/${companyId}/notification-settings`, {
			body : payload
		});

		if (response.success)
		{
			return response.data.notificationSettings;
		}
		else
		{
			throw new Error(response.message || 'Failed to update notification settings');
		}
	}
	catch (error)
	{
		console.error('Error updating notification settings:', error);
		throw error;
	}
};